import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import SystemsWhispererSection from "@/components/sections/SystemsWhispererSection";
import { SEO } from "@/components/SEO";

const SystemsWhisperer = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Systems Whisperer | It's All About Growth"
        description="A short diagnostic that surfaces where your revenue system leaks — and what to fix first."
        path="/systems-whisperer"
      />
      <Header />
      <main className="pt-20">
        <SystemsWhispererSection />
      </main>
      <Footer />
    </div>
  );
};

export default SystemsWhisperer;
